// extracted by mini-css-extract-plugin
export default {"day":"Day_day__emrmZ","day__sub-title":"Day_day__sub-title__u4zfl","day__title":"Day_day__title__SNvsA"};